import { STATUS_CARD, HAN_THE_OPTIONS } from "assets/constants/card-types";
import { FIELD_TYPE } from "types/enums"
import { ColumnsEdit } from "types/models/column-table-edit";

const {INPUT, DATE, SELECT, AUTO_COMPLETE, CURRENCY, DATE_ON, NUMBER, CHECKBOX, RADIO, NORMAL_CHECKBOX} = FIELD_TYPE;

const cssProps = {
  labelCol: {xs: 8, sm: 8, md: 8, lg: 8, xl: 8},
  wrapperCol: {xs: 16, sm: 16, md: 16, lg: 16, xl: 16},
  css: {xs: 24, sm: 24, md: 24, lg: 8, xl: 8},
};

const cssProps2 = {
  labelCol: {xs: 8, sm: 8, md: 8, lg: 8, xl: 8},
  wrapperCol: {xs: 16, sm: 16, md: 16, lg: 16, xl: 16},
  css: {xs: 24, sm: 24, md: 24, lg: 12, xl: 12},
}

const inputFields = (thuocs, form) => {
  const onSelect = (value, options) => {
    let tmp = thuocs.find(it => it.name === value);
    form.setFieldsValue({
      maThanhPhan: tmp.id,
      giaBHYT: tmp.bhChiTra,
      nhom: "Thuốc",
      hoatChat: tmp.hoatChat,
      dvt: tmp.donViTinh
    });
  }
  return [
  {
    type: INPUT,
    name: "maThanhPhan",
    label: "Mã thuốc",
    disabled: true,
    allowClear: true,
    ...cssProps
  },
  {
    type: AUTO_COMPLETE,
    name: "tenThanhPhan",
    label: "Tên thuốc",
    allowClear: true,
    ...cssProps,
    options: thuocs.map(it => ({
      value: it.name,
      label: it.name
    })),
    onSelect: onSelect
  },
  {
    type: CURRENCY,
    name: "giaBv",
    label: "Giá BV",
    allowClear: true,
    ...cssProps
  },
  {
    type: CURRENCY,
    name: "giaBHYT",
    label: "Giá BHYT",
    allowClear: true,
    disabled: true,
    ...cssProps
  },
 
  {
    type: INPUT,
    name: "nhom",
    label: "Nhóm",
    allowClear: true,
    disabled: true,
    ...cssProps
  },
  {
    type: INPUT,
    name: "hoatChat",
    label: "Hoạt chất",
    allowClear: true,
    disabled: true,
    ...cssProps
  },
  {
    type: INPUT,
    name: "dvt",
    label: "Đơn vị tính",
    allowClear: true,
    disabled: true,
    ...cssProps
  },
  {
    type: INPUT,
    name: "ghiChu",
    label: "Ghi chú",
    allowClear: true,
    ...cssProps
  },
]}

export {
  inputFields
}